import { IIoCContainer, IWebCoreSettings } from '@lmnop/web-core';
import { CoreModulesIoC } from './core-modules-ioc.class';

export interface IAngularCoreIoCContainer extends IIoCContainer {
    core: CoreModulesIoC;
    settings: IWebCoreSettings;
}
